import BarChart from "components/charts/BarChart";
import { barChartDataDailyTraffic } from "variables/charts";
import { barChartOptionsDailyTraffic } from "variables/charts";

const TokenChart = (props: {days: number}) => {
  const { days } = props;
  return (
    <div className="pt-5 text-center">
      <div className="h-full w-full">
        <BarChart
          days={days}
          chartData={barChartDataDailyTraffic}
          chartOptions={barChartOptionsDailyTraffic}
        />
      </div>
    </div>
  );
};

export default TokenChart;
